/**
 * Tarifas Bancárias Cartões
 * (prototype: erpone_tarifas_banc_rias_cart_es)
 *
 * Contrato: GET /finance/bank-tariffs?channel=CARD → PaginatedResponseDto<BankTariffResponseDto>
 * As tarifas de cartão trazem modality + brand (Modalidade / Bandeira) e
 * chargeType PERCENTAGE (Taxa Atual em %).
 */
import { BankTariffsChannelPage } from './BankTariffsChannelPage';

export function BankTariffsCardPage(): JSX.Element {
  return (
    <BankTariffsChannelPage
      channel="CARD"
      title="Tarifas Bancárias — Cartões"
      subtitle="Modalidade e bandeira por tipo de taxa."
      showModalityBrand
    />
  );
}